/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ClientManualMerge {

    interface ClientMerge {
        clientId: Guid;
        isPrimary: boolean;
        info?: any;
    }

    interface GroupMerge {
        clientsToMerge: Array<ClientMerge>
    }

    export class ClientManualMergeContext {

        itemsArrayCtrl: any;
        itemsArrayCtrlBackup: any;
        selectAllBox: boolean;
        mode: Meevo.Model.MaintenanceFormState;
        private backup: any;
        public criteria: any;
        public isFilterHidden: boolean = false;
        public isCentralOffice: boolean = this.identityService.inCentralOfficeMode();
        public clientCriteria = {
            view: Model.ClientSearchView.FromDataMaintenance,
            excludeIdList: [],
            isGlobal: this.isCentralOffice
        }
        public groupsForMerge: Array<Array<ClientMerge>> = [];
        private searchClient: any;
        private indexOfExpandedItem: number = null;
        private excludeIds: Array<string>;
        private indexOfPrimaryClient: number;
        private clientsDates = {};

        constructor(
          protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected $rootScope: angular.IRootScopeService) {
          this.getDefaultCriteria();
          this.mode = Meevo.Model.MaintenanceFormState.Readonly;
        
          // required to display pager controls
          if (device.mobile()) {
              this.isFilterHidden = true;
          }

          this.getExcludeIds();
        }
        
        getDefaultCriteria() {
          this.criteria = {
            filter: '',
            showExcludeFromMerge: false,
            includeInactive: 0
          };
          return this.criteria;
        }
        
        applyFilter(criteria: any, applyFilter: Function): void {
            applyFilter();
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientManualMerge, Model.VerbEnum.ApplyButtonClicked, null);
        }
        
        clearField(applyFilter: Function, $event?) {
            if ($event) {
                $event.stopPropagation();
            }
            this.criteria.showExcludeFromMerge = false;
            applyFilter();
        }
        
        /**
         * Add duplicate client to appropriate goup
         * @param {number} groupIndex
         */
        addDuplicateClient(isGroupForAdd: boolean, groupIndex?: number, mergeGroup?: any): void {
            if (isGroupForAdd) this.groupsForMerge[groupIndex].push({ clientId: null, isPrimary: false })
            else mergeGroup.clientsToMerge.push({ clientId: null, isPrimary: false })
        }

        /**
         * Remove client profile from appropriate goup
         * @param groupIndex
         * @param clientIndex
         */
        removeDuplicateClient(isGroupForAdd: boolean, clientIndex: number, groupIndex?: number, mergeGroup?: any): void {
            if (isGroupForAdd) this.groupsForMerge[groupIndex].splice(clientIndex, 1);
            else {
                mergeGroup.clientsToMerge.splice(clientIndex, 1);
                this.setIndexForPrimaryClient(groupIndex)
            }

            this.clientChanged(isGroupForAdd);
        }

        /**
         * Handler for adding one new merge group
         * */
        addMergeGroup(): void {
            this.groupsForMerge.push(...this.baseGroupForMerge);
        }

        removeMergeGroup(isGroupForAdd: boolean, groupIndex?: number): void {
            if (isGroupForAdd) this.groupsForMerge.splice(groupIndex, 1);
            else {
                const removedGroup = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage].splice(groupIndex, 1);
                const isInBackup = this.itemsArrayCtrlBackup.pages[this.itemsArrayCtrl.currentPage]
                    .some(group => group.mergeGroupId === removedGroup[0].removedGroup);

                if (isInBackup) {
                    this.itemsArrayCtrlBackup.pages[this.itemsArrayCtrl.currentPage].splice(groupIndex, 1);
                }

                this.indexOfExpandedItem = null;
            }

            this.clientChanged(isGroupForAdd);
        }
        
        save(collapseAll, criteria, applyFilter, initializeCriteria): void {
            if (!this.isGroupValid(this.groupsForMerge)) {
                this.modalService.alert('MESSAGE_CONFIRM_MANUAL_MERGE_VALIDATION');
        
                return;
            }
            if (!this.isGroupValid(this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage].map((group) => {
                return group.clientsToMerge.map(client => ({ info: client.id || client.clientId, isPrimary: client.isPrimary }))
            }))) {
                this.modalService.alert('MESSAGE_CONFIRM_MANUAL_MERGE_VALIDATION');

                return;
            }

            //map edited groups to common model structure 
            let updatedItems = this.mapEditedGroups(this.itemsArrayCtrl);
            let updatedItemsBackup = [];

            if (this.itemsArrayCtrlBackup && this.itemsArrayCtrlBackup.pages.length) {
                updatedItemsBackup = this.mapEditedGroups(this.itemsArrayCtrlBackup)

                for(let i = 0, l = updatedItems.length; i < l; i++) {
                    for(let j = 0, ll = updatedItemsBackup.length; j < ll; j++) {
                        if(updatedItems[i].groupId === updatedItemsBackup[j].groupId) {
                            updatedItems.splice(i, 1, updatedItemsBackup[j]);
                            break;
                        }
                    }
                }
            }

            //Check validation of edited group

            const groupItems = {
                groupsToMerge: [
                    ...this.groupsForMerge.map((groupClients): GroupMerge => {
                        return {
                            clientsToMerge: groupClients.map(client => {
                                if (!client.info) return;
                                return { clientId: client.info.id, isPrimary: client.isPrimary }
                            })
                        }
                    }),
                    ...updatedItemsBackup,
                ]
            };

            this.modalService.alert(
                    'MESSAGE_CONFIRM_FOR_MANUAL_MERGE',
                    Meevo.Components.Modal.ModalTranslationModes.Translate,
                    true,
                    { showCancelButton: true, okButtonContentKey: 'LABEL_YES', cancelButtonContentKey: 'LABEL_NO' })
                .then((ss) => {
                    return this.dataService.add(this.appSettings.API_ENDPOINTS.clientManualMerge, groupItems)
                        .then((updateResponse: any) => {

                            if (updateResponse.validationMessage) {
                                //this.updateMergeValidationStatus(updateResponse.invalidDetails);
                                console.log(updateResponse.validationMessage);
                                // Emit error to framework dialog system
                                this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION,
                                    updateResponse.validationMessage,
                                    Meevo.Model.NotificationModeType.Modal,
                                    true);
                            } else {
                                this.resetCriteria( initializeCriteria );
                                this.indexOfExpandedItem = null;
                                this.groupsForMerge = [];
                                this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                                this.applyFilter(criteria, applyFilter);
                                this.getExcludeIds();
                            }


                        })
                });
        
        }

        /**
         * Check groups validation
         * @param {Array<Array<ClientMerge>>} groupsForMerge
         */
        isGroupValid(groupsForMerge: Array<Array<ClientMerge>>): boolean {
            return groupsForMerge.every((clientGroup: Array<ClientMerge>, index: number) => {
                const isPrimaryClientNotEmpty = clientGroup.some(client => client.isPrimary && client.info);
                const isDuplicateClientExist = clientGroup[this.indexOfFirstDuplicateClient].info; // index of first duplicate client from merge group
        
                return isPrimaryClientNotEmpty && isDuplicateClientExist;
            });
        }

        mapEditedGroups(source) {
            return source.pages[this.itemsArrayCtrl.currentPage].map((group: any) => {
                return {
                    clientsToMerge: group.clientsToMerge.map((client) => {
                        return {
                            clientId: client.id || client.clientId,
                            isPrimary: client.isPrimary
                        }
                    }),
                    groupId: group.mergeGroupId
                }
            });
        }

        //Primary client and First Duplicate client is required
        isFieldRequired(index): boolean {
            return index === this.indexOfPrimaryClient || index === this.indexOfFirstDuplicateClient;
        }
        
        edit(): void {
            //this.indexOfExpandedItem = null;
            this.takeBackup();
            this.mode = Meevo.Model.MaintenanceFormState.Editing;
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientManualMerge, Model.VerbEnum.EditButtonClicked, null);
        }
       
        cancel(): void {
            this.groupsForMerge = []
            this.clientCriteria.excludeIdList = this.excludeIds;

            this.rollbackChanges();
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientManualMerge, Model.VerbEnum.CancelButtonClicked, null);
        }

        /**
         * On client change run this function
         * to update client ids for exclude from client list
         * */
        clientChanged(isGroupForAdd?: boolean, client?: any, clientIndex?: number, groupIndex?: number): void {
            if (client && !this.checkLocationIsValid(true, client, clientIndex, groupIndex)) return;

            if(client){
                this.getClientManualMergeRequest(client.id).then((clientDetais: any) => {
                    client = Object.assign(client, clientDetais);
                });
            }

            this.clientCriteria.excludeIdList = [...this.excludeIds];
            
            //mark group for create
            this.groupsForMerge.forEach(group => {
                //find clients with profile
                const clients = group.filter(client => client.info).map(client => client.info.id);
                if (clients.length) this.clientCriteria.excludeIdList.push(...clients);
            });
            //mark group for edit
            this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage].forEach(group => {
                //find clients with profile
                const clients = group.clientsToMerge.filter(client => client).map(client => client.id || client.clientId);
                if (clients.length) this.clientCriteria.excludeIdList.push(...clients);
            });

            this.clientCriteria.excludeIdList = _.uniq(this.clientCriteria.excludeIdList, id => id);
        }

        getLastVisitDateAndService(clientIds: string[]) {
            return this.dataService.add(`${this.appSettings.API_ENDPOINTS.clientMerge}/clientDetails/List`, { clientIds });
        }

        getClientManualMergeRequest(id: string) {
            
            return this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.clientManualMerge}/clientDetails/${id}`);
        }

        changedClientForEdit(mergeGroup?: any, clientIndex?: number, client?: any, isPrimary?: boolean) {
            if (client && client.homeLocationId && !this.checkLocationIsValid(false, client, clientIndex, null, mergeGroup)) return;

            mergeGroup.clientsToMerge[clientIndex] = { ...client, isPrimary };

            this.clientChanged();
        }

        /**
         * Check If we selected client from another location
         * @param isGroupForAdd
         * @param client
         * @param clientIndex
         * @param groupIndex
         * @param mergeGroup
         */
        checkLocationIsValid(isGroupForAdd, client, clientIndex, groupIndex?, mergeGroup?): boolean {
            if (this.identityService.locationId === client.homeLocationId || this.isCentralOffice) return true;

            this.modalService.alert('TEXT_VALIDATION_LOCATION_WARNING');

            if (isGroupForAdd) {
                this.groupsForMerge[groupIndex][clientIndex].info = null;
            } else {
                mergeGroup.clientsToMerge[clientIndex] = {}
                this.clientChanged();
            }

            return false;
        }

        changeSerchCriteria() {
            this.criteria.filter = this.searchClient && this.searchClient.lastName;
        }

        goToClient(clientId: string, alertType: any) {
            const actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionStateParam,
                    id: clientId
                },
                clientAlertType: (_.isNumber(alertType) ? alertType : null)
            });
        }

        expand(index) {
            if (this.indexOfExpandedItem === index) {
                this.indexOfExpandedItem = null;
            }
            else {
                this.indexOfExpandedItem = index;
                this.setIndexForPrimaryClient(index);
            }
        }

        isItemExpanded(index) {
            return this.indexOfExpandedItem === index;
        }

        onPageLoaded(): void {
            if (this.itemsArrayCtrl.count === 0) {
                this.groupsForMerge = this.baseGroupForMerge;
            } else {
                this.getDateLastVisit(); 
            }
        }

        private getDateLastVisit() {
            this.itemsArrayCtrl.pages.forEach((pages, pageIndex) => {
                pages.forEach((mergeGroup, mergeFroupIndex) => {
                    mergeGroup.clientsToMerge.forEach((group, groupIndex) => {
                        this.clientsDates[`${group.clientId}`] = {
                            linkToObject: this.itemsArrayCtrl.pages[pageIndex][mergeFroupIndex].clientsToMerge[groupIndex]
                        }
                    });
                });
            });

            this.itemsArrayCtrlBackup = Object.assign({}, this.itemsArrayCtrl);

            if (Object.keys(this.clientsDates).length) {
                this.getLastVisitDateAndService(Object.keys(this.clientsDates)).then(clientsDates => {
                    clientsDates.forEach(client => {
                        this.clientsDates[`${client.id}`].linkToObject.recentServices = client.recentServices;
                        this.clientsDates[`${client.id}`].linkToObject.visitDates = client.visitDates;
                    })
                });
            }
        }

        private resetCriteria(resetFunc?: any) {
            if (resetFunc) {
                resetFunc();
            }

            this.getDefaultCriteria();
            this.searchClient = null;
        }

        private setIndexForPrimaryClient(groupIndex: number) {
            this.indexOfPrimaryClient = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage][groupIndex].clientsToMerge.findIndex(client => client.isPrimary)
        }

        private getExcludeIds() {
            return this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.clientManualMerge}/ClientManualMergeIds`).then((ids: Array<string>) => {
                this.excludeIds = ids;
                this.clientCriteria.excludeIdList = ids;
            })
        }

        get indexOfFirstDuplicateClient() {
            return this.indexOfPrimaryClient === 0 ? 1 : 0;
        }

        get baseGroupForMerge(): Array<Array<ClientMerge>> {
            return [
                [
                    {
                        clientId: null,
                        isPrimary: true
                    },
                    {
                        clientId: null,
                        isPrimary: false
                    }
                ]
            ]
        }

        get isEditing(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Editing;
        }
        
        get isReadonly(): boolean {
            return this.mode == Meevo.Model.MaintenanceFormState.Readonly;
        }
        
        private takeBackup() {
            this.backup = angular.copy(this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage]);
        }
        
        private rollbackChanges() {
            this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage] = angular.copy(this.backup);
            this.backup = null;
        }

        private usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum, payload): void {
            if (nounEnum != null) {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

    }
}